import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';

import { faIdBadge } from '@fortawesome/free-regular-svg-icons';
import {
    faAddressCard,
    faChartColumn,
    faDownload,
    faHouse,
    faMoneyBill,
    faNewspaper,
    faUser,
    faVrCardboard,
} from '@fortawesome/free-solid-svg-icons';

import MenuItem from './MenuItem';

function MenuAside({ isMenuOpen }) {
    const location = useLocation().pathname;

    const [openMenuIndex, setopenMenuIndex] = useState(null);

    const toggleMenu = (index) => {
        setopenMenuIndex(openMenuIndex === index ? null : index);
    };

    const menus = [
        { label: 'Início', icon: faHouse, href: '/manager', locations: ['/manager/', '/manager'] },
        {
            label: 'Produtos',
            icon: faVrCardboard,
            locations: [
                /^\/manager\/produtos\/?$/,
                /^\/manager\/produtos\/adicionar\/?$/,
                /^\/manager\/produtos\/editar\/.*/,
                /^\/manager\/produtos\/videos\/.*/,
                /^\/manager\/videos\/adicionar\/.*/,
                /^\/manager\/videos\/editar\/.*/,
                /^\/manager\/produtos\/imagens\/.*/,
                /^\/manager\/imagens\/adicionar\/.*/,
                /^\/manager\/imagens\/editar\/.*/,
                /^\/manager\/categorias\/?$/,
                /^\/manager\/categorias\/adicionar\/?$/,
                /^\/manager\/categorias\/editar\/.*/,
            ],
            subMenu: [
                { label: 'Produtos', href: '/manager/produtos' },
                { label: 'Categorias', href: '/manager/categorias' },
            ],
        },
        {
            label: 'Representantes',
            icon: faMoneyBill,
            locations: [
                /^\/manager\/representantes\/?$/,
                /^\/manager\/representantes\/adicionar\/?$/,
                /^\/manager\/representantes\/editar\/.*/,
            ],
            href: '/manager/representantes',
            // subMenu: [
            //     { label: 'Todos os Representantes', href: '/manager/representantes' },
            //     { label: 'Ranking', href: '/manager/representantes/ranking' }
            // ]
        },
        {
            label: 'Destaques',
            icon: faNewspaper,
            href: '/manager/destaques',
            locations: [/^\/manager\/destaques\/?$/, /^\/manager\/destaques\/adicionar\/?$/, /^\/manager\/destaques\/editar\/.*/],
        },
        {
            label: 'Downloads',
            icon: faDownload,
            href: '/manager/downloads/tipos',
            locations: [
                /^\/manager\/downloads\/tipos\/?$/,
                /^\/manager\/downloads\/tipos\/adicionar\/?$/,
                /^\/manager\/downloads\/tipos\/editar\/.*/,
                /^\/manager\/downloads\/categorias\/.*/,
                /^\/manager\/downloads\/categorias\/adicionar\/.*/,
                /^\/manager\/downloads\/categorias\/editar\/.*/,
                /^\/manager\/downloads\/arquivos\/.*/,
                /^\/manager\/downloads\/arquivos\/adicionar\/.*/,
                /^\/manager\/downloads\/arquivos\/editar\/.*/,
            ],
        },
        {
            label: 'Contatos',
            icon: faAddressCard,
            href: '/manager/contatos',
            locations: [/^\/manager\/contatos\/?$/, /^\/manager\/contatos\/adicionar\/?$/, /^\/manager\/contatos\/editar\/.*/],
        },
        {
            label: 'Usuários internos',
            icon: faIdBadge,
            href: '/manager/usuarios-internos',
            locations: [
                /^\/manager\/usuarios-internos\/?$/,
                /^\/manager\/usuarios-internos\/adicionar\/?$/,
                /^\/manager\/usuarios-internos\/editar\/.*/,
            ],
        },
        {
            label: 'Administradores',
            icon: faUser,
            href: '/manager/usuarios',
            locations: [/^\/manager\/usuarios\/?$/, /^\/manager\/usuarios\/adicionar\/?$/, /^\/manager\/usuarios\/editar\/.*/],
        },
        {
            label: 'Relatórios',
            icon: faChartColumn,
            href: '/manager/relatorios',
            locations: [/^\/manager\/relatorios\/?$/],
        },
    ];

    return (
        <aside
            className={`fixed left-0 top-16 lg:top-0 max-lg:bottom-0 z-9999 flex h-screen w-50 md:w-64 xl:w-72 flex-col overflow-y-auto bg-primary duration-300 ease-linear lg:static z-[10] lg:translate-x-0 -translate-x-full${isMenuOpen ? 'translate-x-0' : ''}`}
        >
            <div className="hidden lg:flex items-center justify-between gap-2 px-6 py-5 lg:py-6">
                <Link to="/manager">
                    <img src={`/assets/img/admin/rometal-logo.png`} className="w-5/6" alt="Logo" />
                </Link>
            </div>

            <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
                <nav className="mt-5 px-4 py-4 lg:mt-8 lg:px-6">
                    <div>
                        <h3 className="mb-4 ml-4 text-sm font-medium text-white">MENU</h3>

                        <ul className="mb-6 flex flex-col gap-1.5">
                            {menus.map((menu, index) => (
                                <MenuItem
                                    key={index}
                                    index={index}
                                    label={menu.label}
                                    icon={menu.icon}
                                    subMenu={menu.subMenu}
                                    isOpen={openMenuIndex === index}
                                    onToggle={toggleMenu}
                                    location={location}
                                    locations={menu.locations}
                                    to={menu.href}
                                />
                            ))}
                        </ul>
                    </div>
                </nav>
            </div>
        </aside>
    );
}

export default MenuAside;
